import React from 'react'
import { Link } from 'react-router-dom'
import { FaHome, FaBuilding, FaIndustry, FaTools } from "react-icons/fa";

const More_Hosting = () => {
  return (
    <div>
         <section class="relative bg-black/30">
                              <div class="absolute inset-0 bg-gradient-to-r from-amber-500/5 via-transparent to-amber-500/5 blur-2xl"></div>
                              <div class="relative isolate px-6 py-10 sm:py-10">
                                    <div class="absolute inset-0 -z-10">
                                          <div class="absolute inset-0 bg-gradient-to-b from-[#1b1f24] via-[#14181c] to-[#111315]">
                                          </div>

                                          <div class="absolute inset-0">
                                                <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[150px]">
                                                      <div
                                                            class="absolute inset-0 bg-gradient-to-r from-amber-900/20 to-amber-600/20 blur-[100px] animate-slow-pulse">
                                                      </div>
                                                </div>
                                          </div>
                                    </div>
                                    <div class="relative mx-auto max-w-7xl">
                                          <div class="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6">
                                                <div class="bg-gray-900/50 backdrop-blur-xl rounded-2xl ring-1 ring-white/10 p-4 md:p-8">
                                                      <Link to="/hosting" class="flex items-center gap-12">
                                                            <div class="flex gap-5 items-center">
                                                                  <div class="h-14 w-14 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center text-amber-300">
                                                                        <FaHome size={24} />
                                                                  </div>
                                                                  <h3 class="text-lg font-bold text-white">Residential Construction</h3>
                                                            </div>
                                                      </Link>
                                                </div>
                                                <div class="bg-gray-900/50 backdrop-blur-xl rounded-2xl ring-1 ring-white/10 p-4 md:p-8">
                                                      <Link to="/hosting" class="flex items-center gap-12">
                                                            <div class="flex gap-5 items-center">
                                                                  <div class="h-14 w-14 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center text-amber-300">
                                                                        <FaBuilding size={24} />
                                                                  </div>
                                                                  <h3 class="text-lg font-bold text-white">Commercial Construction</h3>
                                                            </div>
                                                      </Link>
                                                </div>
                                                <div class="bg-gray-900/50 backdrop-blur-xl rounded-2xl ring-1 ring-white/10 p-4 md:p-8">
                                                      <Link to="/hosting" class="flex items-center gap-12">
                                                            <div class="flex gap-5 items-center">
                                                                  <div class="h-14 w-14 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center text-amber-300">
                                                                        <FaIndustry size={24} />
                                                                  </div>
                                                                  <h3 class="text-lg font-bold text-white">Industrial Construction</h3>
                                                            </div>
                                                      </Link>
                                                </div>
                                                <div class="bg-gray-900/50 backdrop-blur-xl rounded-2xl ring-1 ring-white/10 p-4 md:p-8">
                                                      <Link to="/hosting" class="flex items-center gap-12">
                                                            <div class="flex gap-5 items-center">
                                                                  <div class="h-14 w-14 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center text-amber-300">
                                                                        <FaTools size={24} />
                                                                  </div>
                                                                  <h3 class="text-lg font-bold text-white">Renovation and Interior Fitout</h3>
                                                            </div>
                                                      </Link>
                                                </div>

                                          </div>
                                    </div>
                              </div>
                        </section>
    </div>
  )
}

export default More_Hosting
